// Import Redux
import { AnyAction } from 'redux'
// Import Redux Types
import {
  OPEN_MODAL,
  CLOSE_MODAL,
  SET_DATA_MODAL
} from '../types/index'



// State Reducer
const initialState = {
  isOpen: false,
  modalTypes: [
    {
      id: 'message',
      isVisible: false,
      hasClose: true,
      title: '',
      text: '',
      btn: {
        text: '',
        link: '/'
      }
    },
    {
      id: 'offering',
      idOffering: 0,
      isVisible: false,
      hasClose: true,
      name: '',
      age: '',
      dedicatedText: '',
      dedicatedBy: '',
      shareBtn: true,
      downloadBtn: true
    },
    {
      id: 'success',
      idOffering: 0,
      isVisible: false,
      hasClose: false,
      title: '',
      text: '',
      photo: '',
      btn: {
        text: '',
        link: '/'
      },
      shareBtn: true,
      downloadBtn: true
    }
  ]
}



export default ( state = initialState, action:AnyAction ) => {
  switch( action.type ) {
    case SET_DATA_MODAL:
      return {
        ...state,
        modalTypes: state.modalTypes.map( modalType => {
          if( modalType.id === action.payload.modalType ) {
            return {
              ...modalType,
              ...action.payload.dataModal
            }
          }
          return {
            ...modalType
          }
        } )
      }
    case OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
        modalTypes: state.modalTypes.map( modalType => ({
          ...modalType,
          isVisible: modalType.id === action.payload ? true : false
        }) )
      }
    case CLOSE_MODAL:
      return {
        ...state,
        isOpen: false
      }
    default:
      return {
        ...state
      }
  }
}
